import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details-stack" }

import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppPhoneField from "@/shared/components/ui/AppPhoneField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicInfoForm',
  props: {
    business_name: { default: "" },
    tax_id: { default: "" },
    business_type: {},
    business_email: { default: "" },
    business_phone: { default: "" },
    errors: { default: () => ({}) }
  },
  emits: [
  "update:business_name",
  "update:tax_id",
  "update:business_email",
  "update:business_phone",
],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(AppTextField, {
                "model-value": __props.business_name,
                label: "Business Name",
                "label-icon": "mdi-domain",
                placeholder: "Acme Services LLC",
                "error-messages": __props.errors.business_name ? [__props.errors.business_name] : [],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:business_name', $event)))
              }, null, 8, ["model-value", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(AppTextField, {
                "model-value": __props.business_email,
                label: "Business Email",
                "label-icon": "mdi-email-outline",
                placeholder: "name@company.com",
                "error-messages": __props.errors.business_email ? [__props.errors.business_email] : [],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:business_email', $event)))
              }, null, 8, ["model-value", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(AppPhoneField, {
                "model-value": __props.business_phone,
                label: "Business Phone",
                "label-icon": "mdi-phone-outline",
                placeholder: "(555) 555-5555",
                "error-messages": __props.errors.business_phone ? [__props.errors.business_phone] : [],
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:business_phone', $event)))
              }, null, 8, ["model-value", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(AppTextField, {
                "model-value": __props.tax_id,
                label: __props.business_type === 'freelancer' ? 'Social Security Number' : 'EIN / Tax ID',
                "label-icon": "mdi-domain",
                placeholder: __props.business_type === 'freelancer' ? 'XXX-XX-XXXX' : '12-3456789',
                "error-messages": __props.errors.tax_id ? [__props.errors.tax_id] : [],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:tax_id', $event)))
              }, null, 8, ["model-value", "label", "placeholder", "error-messages"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})